import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {fetchPhotos} from '../api/api';
import Item from './Item';
import Carousel from './Carousel';
import { CircularProgress } from '@material-ui/core';


const styles = theme => ({
  root: {
    margin: '30px 0px'
  }
});

class Photos extends Component {

  state = {
    open: false,
    selected: 0, 
    photos: [], 
    isLoading: false
  }


  componentDidMount() {
    this.loadPhotos(); 
  }

  loadPhotos = async () => {
    this.setState({isLoading: true});
    const photos =  await fetchPhotos({
    }); 
    this.setState({photos, isLoading: false});
   }

  expand = id => {
    const index = this.state.photos.findIndex(photo => photo._id === id);
    this.setState({ selected: index, open: true });
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  handleChange = (selected) => {
    this.setState({ selected });
  }

  render() {
    const { classes } = this.props;
    const { open, selected, photos, isLoading } = this.state;
    if (isLoading) {
      return <CircularProgress />
    }
    return (
      <div className={classes.root}>
        <Grid
          container
          spacing={2}
          direction="row"
          alignItems="flex-start"
        >
          {photos && photos.map(photo => (
                  <Item
                      key={photo.id}
                      section={photo}
                      width={4}
                      expendable
                      type="photo"
                      onExpand={this.expand}
                    /> ))}
        </Grid>
        {photos.length ? 
        <Carousel
          items={photos}
          open={open}
          selected={selected}
          onClose={this.handleClose}
          onChange={this.handleChange}
        />: <>
        </>
      }
      </div>
    )
  }
}

Photos.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Photos);



